var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8346 12.4999C10.8346 12.0397 10.4615 11.6666 10.0013 11.6666C9.54106 11.6666 9.16797 12.0397 9.16797 12.4999V14.1666C9.16797 14.6268 9.54106 14.9999 10.0013 14.9999C10.4615 14.9999 10.8346 14.6268 10.8346 14.1666V12.4999Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0013 5.83325C15.0013 3.07183 12.7627 0.833252 10.0013 0.833252C7.23988 0.833252 5.0013 3.07183 5.0013 5.83325V7.49992C3.16035 7.49992 1.66797 8.9923 1.66797 10.8333V15.8333C1.66797 17.6742 3.16035 19.1666 5.0013 19.1666H15.0013C16.8423 19.1666 18.3346 17.6742 18.3346 15.8333V10.8333C18.3346 8.9923 16.8423 7.49992 15.0013 7.49992V5.83325ZM6.66797 5.83325C6.66797 3.9923 8.16035 2.49992 10.0013 2.49992C11.8423 2.49992 13.3346 3.9923 13.3346 5.83325V7.49992H6.66797V5.83325ZM3.33464 10.8333C3.33464 9.91278 4.08083 9.16658 5.0013 9.16658H15.0013C15.9218 9.16658 16.668 9.91278 16.668 10.8333V15.8333C16.668 16.7537 15.9218 17.4999 15.0013 17.4999H5.0013C4.08083 17.4999 3.33464 16.7537 3.33464 15.8333V10.8333Z",
    fill: "#9D9D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/passwordIcon.22502efb53a0ae4299771ca27252d2a9.svg";
export { ForwardRef as ReactComponent };